<template>
  <Modal
    id="modal-legacy-feature"
    :visible="visible"
    data-cy="modal-legacy-feature"
    :modal="true"
    :draggable="false"
    append-to="self"
    :close-on-escape="false"
    :class="$style.modal"
    :closable="false"
    :dismissable-mask="false"
  >
    <template #header>
      <h2>You are navigating to Legacy Capital Advances</h2>
    </template>
    <div :class="$style['modal-content']">
      <div :class="$style['subtitle-container']">
        <p>
          Capital Advances are legacy Clearco marketing and inventory products.
          Functionality is limited. Navigate back to
          <a
            style="text-decoration: underline; cursor: pointer"
            @click.prevent="$router.push('/')"
          >
            {{ 'Funding' }}
          </a>
          to fund your invoices and receipts.
        </p>
      </div>
    </div>
    <div :class="$style['btn-container']">
      <DSButton
        class="p-button-outlined p-button-secondary w-full"
        label="Cancel"
        @click="handleCancelClick"
      />
      <DSButton class="w-full" label="Continue" @click="handleContinueClick" />
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/shared/Dialog.vue';
import DSButton from 'primevue/button';
import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';

export default {
  components: {
    Modal,
    DSButton,
  },
  props: {
    visible: Boolean,
  },
  computed: {
    ...mapGetters(['userId', 'business']),
  },
  methods: {
    handleContinueClick() {
      analytics.track(SEGMENT_EVENTS.legacy_modal_continue, {
        route: this.$route.name,
        userId: this.userId,
        businessId: this.business.id,
      });
      this.$store.dispatch('setShowLegacyModal', false);
    },
    handleCancelClick() {
      analytics.track(SEGMENT_EVENTS.legacy_modal_cancel, {
        userId: this.userId,
        businessId: this.business.id,
        route: this.$route.name,
      });
      this.$router.push('/');
    },
  },
};
</script>

<style lang="less" module>
.modal {
  padding: 0;
  h2 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    font-family: @regular-font;
  }
  svg {
    height: 100px;
    width: 100%;
  }
}
.btn-container {
  text-align: center;
  display: flex;
  gap: 16px;
}
.modal-content {
  max-width: 700px;
  text-align: center;
  margin: 10px;
}
.title-container {
  margin: 0;
  h1 {
    margin: 0;
  }
}
.subtitle-container {
  margin-bottom: 40px;
}
</style>
